import { GetterTree } from 'vuex';
import { IPropertyEditState } from '../property-states.store';

const constructionGetters: GetterTree<IPropertyEditState, {}> = <GetterTree<IPropertyEditState, {}>>{
    service: (state: IPropertyEditState) => state.service,
}

export default constructionGetters;
